import React, { HTMLAttributes, useRef } from 'react'
import * as S from './styled'
import IconSearch from '@components/Icons/IconSearch'

export interface SearchBlockMobileProps {
    placeholder?: string
    searchHandler?: () => void
    searchState: {
        searchText: string
        searchRef?: React.RefObject<HTMLInputElement>
        changeSearchText: (payload: string) => void
        focusHandler?: (el: any) => any
        blurHandler?: (el: any) => any
        atrs?: HTMLAttributes<HTMLInputElement>
    }
}

export const SearchBlockMobile = (props: SearchBlockMobileProps) => {
    const newSearchRef = useRef<HTMLInputElement>(null)
    const searchRef = props.searchState.searchRef || newSearchRef

    const keyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!props.searchHandler) return
        if (e.key === 'Enter') {
            props.searchHandler()
            if (searchRef?.current) searchRef.current.blur()
        }
    }
    const clearText = () => {
        props.searchState.changeSearchText('')
        if (searchRef?.current) searchRef.current.focus()
    }
    const changeSearchTextHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.searchState.changeSearchText(e.target?.value || '')
    }

    return (
        <S.Container>
            <S.IconContainer>
                <IconSearch />
            </S.IconContainer>
            <S.InputContainer>
                <S.Input
                    data-search-input
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    value={props.searchState.searchText}
                    onChange={changeSearchTextHandler}
                    onKeyDown={keyDownHandler}
                    placeholder={props.placeholder}
                    ref={searchRef}
                    onFocus={props.searchState.focusHandler}
                    onBlur={props.searchState.blurHandler}
                    {...props.searchState.atrs}
                />
                {props.searchState.searchText && (
                    <S.CancelButtonContainer onClick={clearText}>
                        <S.CancelButton />
                    </S.CancelButtonContainer>
                )}
            </S.InputContainer>
            {/* {props.searchState.searchText && props.searchHandler ? (
                <S.ButtonSearch data-search-submit onClick={searchInsideHandler} onTouchEnd={searchInsideHandler}>
                    Найти
                </S.ButtonSearch>
            ) : (
                <React.Fragment />
            )}*/}
        </S.Container>
    )
}

/*export const SearchCustomBlockMobile = (props: SearchBlockMobileProps) => {
    const searchRef = useRef<HTMLInputElement>(null)

    const keyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!props.searchHandler) return
    }

    const clearText = () => {
        props.searchState.changeSearchText('')
        if (searchRef?.current) searchRef.current.focus()
    }
    const changeSearchTextHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.searchState.changeSearchText(e.target?.value || '')
    }

    return (
        <S.Container>
            <S.IconContainer>
                <IconSearch />
            </S.IconContainer>
            <S.InputContainer>
                <S.Input
                    value={props.searchState.searchText}
                    onChange={changeSearchTextHandler}
                    onKeyDown={keyDownHandler}
                    placeholder={props.placeholder}
                    ref={searchRef}
                />
                {props.searchState.searchText && (
                    <S.CancelButtonContainer onClick={clearText}>
                        <S.CancelButton />
                    </S.CancelButtonContainer>
                )}
            </S.InputContainer>
        </S.Container>
    )
}*/
